import React from 'react';
import { motion } from 'framer-motion';
import { imageCache } from '../utils/imageCache';

const OfferCard = ({ offer, index }) => {
  const getEmoji = () => {
    // Usar el emoji de la base de datos si existe, sino usar uno por defecto
    return offer.categoryEmoji || '🏷️';
  };



  // La función generateWhatsAppLink ya no es necesaria si el enlace es fijo
  // const generateWhatsAppLink = (offerTitle) => {
  //   const phoneNumber = '51987654321'; // Reemplaza con tu número de WhatsApp
  //   const message = `¡Hola! Estoy interesado/a en la oferta: "${offerTitle}". ¿Podrías darme más información?`;
  //   return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  // };

  const beaconsAiLink = "https://beacons.ai/miamarketfood"; // Enlace fijo

  return (
    <motion.div
      className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 cursor-pointer h-full flex flex-col"
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      whileHover={{ scale: 1.03, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageCache.getCachedUrl(offer.image)}
          alt={offer.title}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
        />
        <div className="absolute bottom-3 right-3 p-2 rounded-full bg-white/90 backdrop-blur-sm shadow-lg">
          <span className="text-2xl">{getEmoji()}</span>
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-800 mb-2" style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          minHeight: '3.5rem'
        }}>
          {offer.title}
        </h3>

        {/* Badge de Categoría */}
        {offer.category && offer.category !== 'Sin categoría' && (
          <div className="mb-3">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
              <span className="mr-1">{offer.categoryEmoji || '🏷️'}</span>
              {offer.category}
            </span>
          </div>
        )}

        {/* Descripción visible solo en desktop */}
        <p className="hidden md:block text-gray-600 text-sm mb-4 flex-grow" style={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}>
          {offer.description}
        </p>

        {/* Precios y botón en la misma línea - siempre al final */}
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2">
            {offer.price !== undefined && offer.price !== null && (
              <span className="text-2xl font-extrabold text-orange-600">
                S/{offer.price.toFixed(2)}
              </span>
            )}
            {offer.originalPrice !== undefined && offer.originalPrice !== null && (
              <span className="text-sm text-gray-400 line-through">
                S/{offer.originalPrice.toFixed(2)}
              </span>
            )}
            {offer.date && (
              <span className="text-sm text-gray-500 flex items-center ml-2">
                <Calendar className="w-4 h-4 mr-1" /> {offer.date}
              </span>
            )}
          </div>

          <motion.a
            href={beaconsAiLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-5 py-2 rounded-full font-semibold text-sm hover:shadow-md transition-all duration-300 flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Pedir
          </motion.a>
        </div>
      </div>
    </motion.div>
  );
};

export default OfferCard;